import { useEffect } from "react"
import { useSiteConfig } from "../hooks/useSiteConfig"
import { setSiteConfig } from "../utils/globalSiteConfig"

/**
 * Component to initialize global site configuration
 * Should be included once in your app (e.g., in Layout component)
 */
export const SiteConfigInitializer = () => {
  const siteConfig = useSiteConfig()

  useEffect(() => {
    // Set the global site config for pixel tracking
    setSiteConfig(siteConfig)
  }, [siteConfig])

  // This component doesn't render anything
  return null
}
